var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0684 10.5L20.0152 1.02744C20.1484 0.87002 20.0364 0.630859 19.8305 0.630859H17.4147C17.2724 0.630859 17.1362 0.694434 17.0423 0.803418L10.4881 8.61699L3.93393 0.803418C3.84311 0.694434 3.70688 0.630859 3.56157 0.630859H1.14575C0.939891 0.630859 0.827879 0.87002 0.961082 1.02744L8.90786 10.5L0.961082 19.9726C0.931244 20.0076 0.912101 20.0506 0.905926 20.0962C0.899752 20.1419 0.906804 20.1883 0.926248 20.2301C0.945691 20.2718 0.976709 20.3071 1.01562 20.3318C1.05453 20.3564 1.09969 20.3694 1.14575 20.3691H3.56157C3.70386 20.3691 3.84009 20.3056 3.93393 20.1966L10.4881 12.383L17.0423 20.1966C17.1332 20.3056 17.2694 20.3691 17.4147 20.3691H19.8305C20.0364 20.3691 20.1484 20.13 20.0152 19.9726L12.0684 10.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.b7ea3f28.svg";
export { ForwardRef as ReactComponent };